import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export const imageInitialValues = (subSection: SubSection) => ({
  imageId: subSection.mediaId || "",
  title: subSection?.title || "",
  src: subSection?.attrs?.src || "",
  alt: subSection?.attrs?.alt || "",
  caption: subSection?.attrs?.caption || "",
});

export const imageValidationSchema = Yup.object({
  src: Yup.string().required("Image is required"),
  alt: Yup.string().required("Alt is required"),
  caption: Yup.string().required("Caption is required"),
});
